export const ACCOUNT_CONSTANTS = Object.freeze({
  ACCOUNT_DEACTIVATE_SUBHEADER:
    'Account deactivation is available when inventory count is 0 and the account does not have ownership of an animal.',
  ACCOUNT_FARM_NAME: 'Account/Farm Name',
  ACCOUNT_INFO: 'Account Information',
  ACCOUNT_TYPE: 'Account Type',
  ACCOUNT: 'Account',
  ADD_ACCOUNT: 'Add Account',
  BILLING_DISABLED_ACCOUNTS_COUNT: 'Total Billing Disabled Accounts:',
  BILLING_ENABLE_DISABLE_MESSAGE: 'Click on the button to Enable/Disable billing',
  CREATE_ACCOUNT_SUBHEADER:
    'Your user profile is not associated with a storage account, please create a storage account to continue.',
  CREATE_ACCOUNT: 'Create Account',
  CREATE_STORAGE_ACCOUNT: 'Create Storage Account',
  DEACTIVATE_ACCOUNT: 'Deactivate account',
  DEACTIVATION: 'Deactivation',
  DISABLE_BILLING: 'Disable Billing',
  DUE_AMOUNT: 'Due Amount',
  DUE_PAYMENT_SUBHEADER: 'There is due payment for this account.',
  ENABLE_BILLING: 'Enable Billing',
  ENABLE_BILLING_SUBHEADER: 'Are you sure you want to enable billing for ',
  MARK_PAID: 'Mark As Paid',
  PENDING_ACH_SUBHEADER: 'There is a pending ACH payment transaction associated with this account.',
  PERMANENT_DISABLE_MESSAGE: 'Do you want to disable billing permanently?',
  SEARCH_ACCOUNT: 'Search Account',
  VERIFY_ACCOUNT: 'Verify Account',
  VERIFY_USER_EMAIL:
    'Please check your email and click the link to verify your email address in order to continue. If you did not receive a verification email or if your link expired, click the button below to send a new link.',
  BILLING_FINALIZATION_NOTE:
    'Disabled accounts are finalized at 11:55 PM on the last day of each month. Changes after this time are not counted.',
});

export const ADDRESS_CONSTANTS = Object.freeze({
  ADD_ADDRESS: 'Add Address',
  ADDRESS_INFO: 'Address Information',
  ADDRESS_LINE_1: 'Address Line 1',
  ADDRESS_LINE_2: 'Address Line 2',
  ADDRESS: 'Address',
  CITY: 'City',
  CONTACT_PHONE: 'Contact Phone',
  COUNTRY_CODE: 'Country Code',
  COUNTRY: 'Country',
  SHIPPING_ADDRESS: 'Shipping Address',
  STATE_REGION: 'State / Region',
  STATE: 'State',
  ZIP_CODE: 'Zip Code',
});

export const ANIMAL_CONSTANTS = Object.freeze({
  ACCOUNT_BUSINESS_FARM: 'Account/Business/Farm',
  ADD_BREED_HEADER: 'Please complete the form to add a new breed.',
  ADD_BREED: 'Add Breed',
  ADD_DOCUMENT: 'Add Document',
  ADD_NEW_ANIMAL: 'Add New Animal',
  ADD_OWNER: 'Add another owner',
  ADD_SPECIES_HEADER: 'Please complete the form to add a new species.',
  ADD_SPECIES: 'Add Species',
  ANIMAL_CODE: 'Animal Code',
  ANIMAL_INFO: 'Animal Information',
  ANIMAL_NAME: 'Animal Name',
  ANIMAL_OWNERSHIP_BREAKDOWN: 'Animal Ownership Breakdown',
  ANIMAL_OWNERSHIP_QUESTION: 'Do you want to add ownership to this animal?',
  ANIMAL_OWNERSHIP: 'Animal Ownership',
  ANIMAL: 'Animal',
  ANIMALS: 'Animals',
  BREED: 'Breed',
  BREEDS: 'Breeds',
  DAM: 'DAM',
  DATE_OF_BIRTH: 'Date of Birth',
  DELETE_DOCUMENT: 'Delete Document',
  DELETE_DOCUMENT_CONFIRM: 'Are you sure you want to delete this document?',
  DESCRIPTION: 'Description',
  DOCUMENT_SUPPORTED_FORMATS: 'Supported formats:',
  DOCUMENT_SUPPORTED_FORMATS_LIST: 'PDF, PNG, JPG/JPEG',
  DOCUMENT_UPLOAD_LIMITS: 'Maximum 5 MB per file • Up to 10 documents',
  DOCUMENT_UPLOAD_SINGLE_FILE_LIMIT: 'Maximum 5 MB per file',
  DOCUMENTS: 'Documents',
  DNA: 'DNA',
  DOB: 'DOB',
  DRAG_DROP_A_FILE: 'Drag and Drop a file here',
  EAR_TAG: 'Ear Tag',
  RFID_EID: 'RFID/EID',
  SCRAPIE_TAG: 'Scrapie Tag',
  EDIT_BREED_HEADER: 'Please complete the form to update your breed.',
  EDIT_BREED: 'Edit Breed',
  EDIT_SPECIES_HEADER: 'Please complete the form to update your species.',
  EDIT_SPECIES: 'Edit Species',
  ENTER_DOCUMENT_DESCRIPTION: 'Enter document description',
  EXPORT_READY: 'Export Ready',
  EXPORT_READY_NO: 'No',
  EXPORT_READY_YES: 'Yes',
  GENDER: 'Gender',
  NO_DOCUMENTS: 'No Documents Available',
  NO_IMAGE: 'No Image Available',
  NO_OWNERSHIP: 'No Ownership Defined',
  OWNERSHIP_100_PERCENT: 'Ownership must add to 100%',
  OWNERSHIP_OVERVIEW_HEADER: 'Please specify each account and their animal ownership percentage.',
  OWNERSHIP_OVERVIEW: 'Ownership Overview',
  OWNERSHIP_PERCENTAGE: 'Ownership %',
  OWNERSHIP_REQUIRED: 'All owners must have a percentage',
  REGISTRATION: 'Registration',
  SIRE: 'Sire',
  SPECIES_NAME: 'Species Name',
  SPECIES: 'Species',
  STORAGE_LOCATIONS: 'Storage Location(s)',
  UPLOAD_DOCUMENT: 'Upload Document',
});

export const BUTTON_CONSTANTS = Object.freeze({
  ACCEPT: 'Accept',
  ADD_ANIMAL: 'Add Animal',
  ADD_DATA_POINT: 'Add Another Data Point',
  ADD_DOCUMENT: '+ Add Document',
  ADD_INVENTORY: 'Add Inventory',
  ADD_LOCATION: 'Add another location',
  ADD_PAYMENT_METHOD: 'Add Payment Method',
  CONTINUE_SETUP: 'Continue Setup',
  SET_UP_PAYOUT_METHOD: 'Set Up Payout Method',
  ADD_TO_CART: 'Add to Cart',
  ADD_TO_MARKETPLACE: 'Add to Marketplace',
  ADD_USER: 'Add User',
  ADD_STAFFS: 'Add Staff Members',
  ADD_STRAWS: 'Add Straws',
  ADD: 'Add',
  ADD_PRODUCT: 'Add Product',
  ADJUST: 'Adjust',
  APPLY: 'Apply',
  BACK: 'Back',
  CANCEL: 'Cancel',
  CHECK: 'Check',
  CLEAR_ALL: 'Clear All',
  CLEAR_CART: 'Clear Cart',
  CHOOSE_FILES: 'Choose Files',
  CLOSE: 'Close',
  COMPLETE: 'Complete',
  CONFIRM: 'Confirm',
  CONTINUE: 'Continue',
  CREATE_NEW_ORDER: 'Create New Order',
  CROSS_SYMBOL: 'X',
  DEACTIVATE: 'Deactivate',
  DECLINE: 'Decline',
  DELETE: 'Delete',
  DISABLE: 'Disable',
  DISCARD: 'Discard',
  DOWNLOAD_CSV: 'Download CSV',
  DOWNLOAD_TEMPLATE: 'Download Template',
  EDIT: 'Edit',
  ENABLE: 'Enable',
  EXPORT_DATA: 'Export Data',
  EXPORT_REPORT: 'Export Report',
  IMPORT: 'Import',
  IMPORT_EXCEL: 'Import Excel',
  LOAD_MORE: 'Load More',
  LOT_INFO: 'Lot Info',
  MOVE: 'Move',
  NEXT_STEP: 'Next Step',
  NO: 'No',
  OK: 'Ok',
  PAY_NOW: 'Pay now',
  PAY: 'Pay',
  PLACE_ORDER: 'Place Order',
  PRINT_AND_PROCESS: 'Print And Process',
  PRINT: 'Print',
  PROCEED_TO_CHECKOUT: 'Proceed to Checkout',
  PROCEED_TO_PAYMENT: 'Proceed to Payment',
  QUICK_VIEW: 'Quick View',
  RECONCILE: 'Reconcile',
  REMOVE: 'Remove',
  RESEND_LINK: 'Resend Link',
  RESEND: 'Resend',
  SAVE_AND_ADD_MORE: 'Save & Add More',
  SAVE_CHANGES: 'Save Changes',
  SAVE_PAY: 'Save & Pay',
  SAVE: 'Save',
  SEE_TRANSACTIONS: 'See Transactions',
  SELL_TRANSFER: 'Sell / Transfer',
  SELECTED: 'Selected',
  SEND: 'Send',
  SIGN_IN: 'Sign In',
  SIGN_OUT: 'Sign Out',
  SIGN_UP: 'Sign Up',
  SUBMIT: 'Submit',
  SYNC: 'Sync',
  UPDATE_EXISTING_ORDER: 'Update Existing Order',
  UPDATE_TOKEN: 'Update token',
  UPDATE: 'Update',
  USE: 'Use',
  VIEW_DETAIL: 'View Detail',
  VIEW_DETAILS: 'View Details',
  VIEW_EDIT: 'View / Edit',
  VIEW_MORE: 'View More',
  UPDATE_PROFILE: 'Update Profile',
  VIEW_PROFILE: 'View Profile',
  VIEW: 'View',
  WITHDRAW_SHIP_PICK_UP: 'Withdraw (Ship/Pick Up)',
  WITHDRAW: 'Withdraw',
  YES: 'Yes',
});

export const INVENTORY_CONSTANTS = Object.freeze({
  ACCOUNT_OWNERS: 'Accounts/Owners',
  ACCOUNTS_WITH_REF_NUMBER: 'Linked Account(s) in the Inventory Application',
  ADD_INSURANCE_PROMPT: 'Would you like to add insurance to your shipment?',
  ADD_INVENTORY_NOTE:
    'In the Notes field, please include information about how you plan to send the specimen and an RSG representative will be in contact with you.',
  ADD_INVENTORY_SUBHEADER:
    'If you have specimen collected/held outside of RSG complete the deposit details below to initiate the transaction.',
  ANIMAL: 'Animal',
  COLLECTED_BY: 'Collected By',
  COLLECTION_SITE: 'Collection Site',
  CUSTOMER_WITH_REF_NUMBER_PREFIX: 'This Reference Number is also associated with',
  CUSTOMER_WITH_REF_NUMBER_SUFFIX: 'in QuickBooks. Would you like to proceed with the update?',
  //TODO: Remove this message when the embryo audit is done
  EMBRYO_AUDIT_IN_PROGRESS_MESSAGE:
    'An embryo audit is currently in progress, and embryo transactions are temporarily unavailable. Transactions will resume as usual once the audit is complete.',
  EMBRYOLOGIST: 'Embryologist',
  EMBRYO_AUDIT_PROGRESS_MESSAGE_FOR_ADMIN:
    'The Audit is in Progress, please add the straw level data and continue with the transactions.',
  EMBRYO_AUDIT_PROGRESS_MESSAGE_FOR_ADMIN_WITH_LOTS: (specimenIds: string) =>
    `The Audit is in Progress for Lot Number(s): ${specimenIds}. Please add the straw level data and continue with the transactions.`,
  //TODO: Uncomment this message when the embryo audit is done
  // EMBRYO_AUDIT_IN_PROGRESS_MESSAGE: (specimenIds: string) =>
  //   `An audit is currently in progress. To proceed with the transaction for Lot Number(s): ${specimenIds}, please contact us by phone at 765-978-0301 or by email at genetics@reprospecialty.us.`,
  ON_FARM_EMBRYO_MISSING_STRAW_DETAILS_MESSAGE: (specimenIds: string) =>
    `Lot Number(s): ${specimenIds} are missing straw details and cannot be selected. Add straw-level details to this Embryo inventory before moving.`,
  FLUSH_MATING: 'Flush Mating',
  FROZEN_BY: 'Frozen By',
  HAVE_SELL_CODE: 'Do you have a sell code?',
  HAVE_TANK: 'Do you need to rent a dry vapor shipper tank from RSG for this shipping order?',
  ITEM_DETAILS: 'Item Details',
  ITEM_OWNERSHIP_BREAKDOWN: 'Item Ownership Breakdown',
  ITEM_TYPE: 'Item Type',
  ITEM_UNIT_MEASURE: 'Item Unit of Measure',
  LOT_DATE: 'Lot Date',
  LOT_NUMBER: 'Lot Number',
  NO_ACCOUNTS_WITH_REF_NUMBER: 'No Account(s) in the Inventory App are linked with the above Reference Number.',
  NO_CUSTOMER_WITH_REF_NUMBER: 'No customer found in QuickBooks with the above Reference Number.',
  ORIGINAL_QUANTITY: 'Original Quantity',
  PROCESSED_BY: 'Processed By',
  PURCHASE_CONGRATS: 'Congratulations on your purchase, please enter the sell code below.',
  QUALITY: 'Quality',
  STRAW_DISTRIBUTION: 'Straw Distribution',
  TECHNICIAN: 'Technician',
  UPDATE_INSURANCE_PROMPT: 'Do you want to add more insurance coverage to your shipment?',
  VETERINARIAN: 'Veterinarian',
});

export const INVENTORY_MANAGEMENT_CONSTANTS = Object.freeze({
  BULK_ORDER_ADD_MORE_FOOTER: 'Please click "save and add more" to save your progress and add additional animals to your order.',
  BULK_ORDER_NEXT_STEP_FOOTER: 'When your order is complete, please click "next step" to finalize your request.',
  COMMON_INVENTORY_FOOTER:
    'Click "Submit" to place your request. An email notification will be sent to you once your request has been successfully processed.',
  CONFIRM_OVERRIDE_QUESTION: 'Are you sure you want to check out more than the requested available quantity?',
  EXISTING_ORDER_FOOTER_NOTE:
    'Please note that if you choose to update the existing order, the shipping address for the entire order will remain as shown above.',
  EXISTING_ORDER_HEADER_NOTE:
    'We found existing pending withdraw order(s). Would you like to add animal to the existing order to avoid additional shipping charges?',
  INSURANCE_AMOUNT_PROMPT:
    'How much would you like to insure your shipment for? The maximum amount allowed is $9,999.00. For amounts of $10,000 or more, please call 765.778.3000 to get a quote. ',
  GROUP_ORDER_ATTENTION: 'Attention: Group Orders',
  INSURANCE_TERMS_ACCEPT: 'I have read and accept the Insurance Terms and Conditions.',
  NO_OPTIONS: 'No Options',
  ON_SITE_SELL_QUESTION: 'Would you like to use now?',
  REVIEW_PURCHASE_INFO_SUBHEADER:
    'Below you will find your semen or embryo withdrawal information, please take a second to review and confirm the purchase details.',
  SELL_INVENTORY_FOOTER:
    'Clicking Submit will transfer these units to the buyers account immediately. This action cannot be cancelled.',
  USE_INVENTORY_HEADER:
    'Complete this form if you would like RSG to handle the deployment of these units at an RSG host site or RSG facility.',
  WITHDRAW_INVENTORY_HEADER:
    "To request a withdraw from your inventory, please use this form. Do not use the 'Withdraw' function if you want RSG to handle the deployment of these units at an RSG host site or facility - instead go to “Use”.",
  WITHDRAW_SHIPPING_NOTE:
    'Please note that delivery time may vary depending on the breeding season, normal delivery times can take anywhere from 1-2 weeks. Additionally, please note there is a cost associated with this option, you will see the grand total once you check out. Kindly provide the mailing address below.',
  WITHDRAW_TERMS_1: 'Frozen Genetics are shipped solely at the risk of the client.',
  WITHDRAW_TERMS_2: 'RSG does not accept any liability for semen or embryos lost, stolen, or damaged.',
  WITHDRAW_TERMS_3: 'Any insurance on the shipment is the responsibility of the client.',
  WITHDRAW_TERMS_ACCEPT: 'I have read and agree to the terms and conditions.',
});

export const LABEL_CONSTANTS = Object.freeze({
  ACCEPTED: 'Accepted',
  ACCOUNT_FARM_NAME: 'Account / Farm Name',
  ACCOUNT_HAS_NO_ANIMAL_OWNERSHIP: 'This Account does not have ownership interest on any animal.',
  ACCOUNT_ID: 'Account ID',
  ACCOUNT_LOCKED: 'Account is locked',
  ACCOUNT_NAME: 'Account Name',
  ACCOUNT_OWNER_ID: 'Account/Owner ID',
  ACCOUNT_OWNER: 'Account/Owner',
  ACCOUNT_OWNERSHIP: 'Account Ownership',
  ACCOUNT_UNLOCKED: 'Account is unlocked',
  ACCOUNTS: 'Accounts',
  ACQUIRED_INVENTORY: 'Recently Acquired Inventory',
  ACTIVE_INACTIVE: 'Active & Inactive',
  ACTIVE: 'Active',
  ADDRESS: 'Address',
  ADD_ACCOUNT_OWNERSHIP: 'Add Account Ownership',
  ADD_CANISTER_HEADER: 'Please complete the form to add a new canister.',
  ADD_CANISTER: 'Add Canister',
  ADD_LOCATION: 'Add Location',
  ADD_PAYMENT_METHOD: 'Add Payment Method',
  ADD_SITE_HEADER: 'Please complete the form to add a new site.',
  ADD_SITE: 'Add Site',
  ADD_STAFF_MEMBER: 'Add Staff Member',
  ADD_STRAW_WARNING: 'This specimen is linked to multiple accounts. Verify straw quantities for each account before proceeding.',
  ADD_TANK_HEADER: 'Please complete the form to add a new tank.',
  ADD_TANK: 'Add Tank',
  ALL: 'All',
  ALL_BREEDS: 'All Breeds',
  ALL_SELLERS: 'All Sellers',
  ALL_TYPES: 'All Types',
  ANIMAL_BREAKDOWN: 'Animal Breakdown',
  ANIMAL_INFO: 'Animal Info',
  ARCHIVED: 'Archived',
  BILLING_STATUS: 'Billing Status',
  BREED_DATE: 'Breed Date',
  BREEDER: 'Breeder',
  BREED_LOCATION: 'Breed Location',
  BREEDER_PROFILE: 'Breeder Profile',
  BULK_DEPOSIT: 'Bulk Deposit',
  BULK_DEPOSIT_INSTRUCTIONS_TITLE: 'How it works',
  BULK_DEPOSIT_INSTRUCTION_DOWNLOAD: 'Download the Excel template.',
  BULK_DEPOSIT_INSTRUCTION_FILL: 'Fill in the required deposit details. Do not change the column headers.',
  BULK_DEPOSIT_INSTRUCTION_IMPORT: 'Upload the completed file to preview and confirm the deposits.',
  BULK_DEPOSIT_PREVIEW: 'Bulk Deposit Preview',
  BULK_DEPOSIT_VALIDATION_HINT: 'Fix the highlighted cells in your Excel file and import again.',
  BULK_DEPOSIT_VALIDATION_TITLE: 'Validation failed',
  BULK_TRANSACTION_ID: 'Bulk Transaction ID',
  BULK_TRANSACTION_LINK_ID: 'Bulk Transaction Link ID',
  BUYER_ACCOUNT: 'Buyer Account',
  BUYER_EMAIL: 'Buyer Email',
  BUYER_FIRST_NAME: 'Buyer First Name',
  BUYER_INFO: 'Buyer Information',
  BUYER_LAST_NAME: 'Buyer Last Name',
  BUYER_PHONE_NUMBER: 'Buyer Phone Number',
  CANISTER_INVENTORY_COUNT: 'Canister Inventory Count',
  CANISTER_CODE: 'Canister Code',
  CANISTER_NAME: 'Canister Name',
  CANISTER: 'Canister',
  CANISTERS: 'Canisters',
  CARRIER_CODE: 'Carrier Code',
  CATALOG_QUANTITY: 'Catalog Quantity',
  CATALOG_REPORT: 'Catalog Report',
  CATALOG_SELL: 'Catalog Sell',
  CHECK_IN_WARNING: 'Check In Warning',
  CHECK_INTO: 'Check Into',
  CHOOSE_PAYMENT_MODE: 'Please choose how you’d like to proceed with payment',
  COLLECT: 'Collect',
  CONFIRM_OVERRIDE: 'Confirm Override of Available Qty',
  CONTACT_EMAIL: 'Contact Email',
  CONTACT_FIRST_NAME: 'Contact First Name',
  CONTACT_LAST_NAME: 'Contact Last Name',
  CONTACT_PHONE: 'Contact Phone',
  COLLECTION_HISTORY: 'Collection History',
  CURRENT_QTY: 'Current Quantity',
  CUSTOMER_INSURANCE_DETAILS: 'Customer Insurance details',
  DATA_POINT_SELECT: 'Custom Data Point Selection',
  DATA_TYPE: 'Data Type',
  DATE_SUBMITTED: 'Date Submitted',
  DATE: 'Date',
  DEACTIVATED: 'Deactivated',
  DECLINED: 'Declined',
  DEPOSIT_DETAILS: 'Deposit Details',
  DEPOSIT: 'Deposit',
  DESIGNATION: 'Designation',
  DISABLE: 'Disable',
  DISABLED_ACCOUNTS_BILLING_HISTORY: 'Disabled Accounts Billing History',
  DOWNLOAD: 'Download',
  DRAG_DROP_FILE: 'Drag and Drop file here',
  DRAG_DROP_FILES: 'Drag and Drop files here',
  DUE_PAYMENT: 'Due Payment',
  DUE: 'Due',
  EDIT_CANISTER_HEADER: 'Please complete the form to update your canister.',
  EDIT_CANISTER: 'Edit Canister',
  EDIT_CUSTOMER_REF_NUMBER: 'Edit QB Reference Number',
  EDIT_PROFILE: 'Edit Profile',
  EDIT_SITE_HEADER: 'Please complete the form to update your site.',
  EDIT_SITE: 'Edit Site',
  EDIT_TANK_HEADER: 'Please complete the form to update your tank.',
  EDIT_TANK: 'Edit Tank',
  EMAIL_ID: 'Email Id',
  EMAIL: 'Email',
  EMBRYO: 'Embryo',
  ENTER_VALID_QUANTITY: 'Please enter a valid quantity.',
  FARM_INFORMATION: 'Farm Information',
  FARM_NAME: 'Farm Name',
  ABOUT_YOUR_FARM: 'About Your Farm',
  MANAGE_PROFILE: 'Manage Profile',
  EMBRYO_DETAILS: 'Embryo Details',
  EMBRYO_TEMPLATE: 'Embryo Template',
  EMBRYO_GRADE: 'Grade',
  EMBRYO_STAGE: 'Stage',
  EMBRYO_STRAWS_TO_USE: 'Embryo Straws to Use',
  EMBRYO_STRAWS: 'Embryo Straws',
  EMBRYOS: 'Embryos',
  ENABLE: 'Enable',
  ENABLED: 'Enabled',
  ENTER_NEW_CARD_DETAILS: 'Enter new card details',
  FILTER_BY: 'Filter By',
  FILTER: 'Filter',
  FIRST_NAME: 'First Name',
  FROM: 'From',
  ID: 'Id',
  INACTIVE: 'Inactive',
  IMPORTING_BULK_DEPOSIT: 'Importing bulk deposit…',
  INFORMATION: 'Information',
  INTERVAL_DAYS: 'Interval (Days)',
  INSURANCE_AMOUNT: 'Insurance Amount',
  INSURANCE_PREMIUM: 'Insurance Premium',
  INSURED_CUSTOMERS_REPORT: 'Insured Customers Report',
  INVENTORY_INTEGRITY: 'Inventory Integrity',
  INVENTORY_ITEMS: 'Inventory Items',
  INVENTORY_LOT_NUMBER: 'Inventory Lot Number',
  INVENTORY_TYPE: 'Inventory Type',
  INVENTORY: 'Inventory',
  ITEM_INFO: 'Item Info',
  ITEM_STORAGE_LOCATIONS: 'Item Storage Location(s)',
  LAST_NAME: 'Last Name',
  LAST_PERFORMED: 'Last Performed',
  LAST_UPDATED_BY: 'Last Updated By',
  LAST_UPDATED: 'Last Updated',
  INITIALS: 'Initials',
  LN2_LEVEL: 'LN2 Level',
  LOG_MAINTENANCE: 'Log Maintenance',
  LOG_TANK_MAINTENANCE: 'Log Tank Maintenance',
  LOT_DATE_NUMBER: 'Lot Date / Number',
  LOT_NO: 'Lot Number',
  LOT_NUMBER_TYPE: 'Lot Number / Type',
  MANAGE_YOUR_BILLING: 'Manage Your Billing',
  MANAGE_VENDOR_INFO: 'Manage Payout Information',
  MAINTENANCE_DISABLED: 'Maintenance disabled',
  MAINTENANCE_HISTORY: 'Maintenance History',
  MAINTENANCE_SETTINGS: 'Maintenance Settings',
  MAINTENANCE_TRACKING: 'Maintenance Tracking',
  MAINTENANCE_TYPE: 'Maintenance Type',
  MARKETPLACE_SPECIMEN_QUANTITY: 'Marketplace Specimen Quantity',
  MARK_AS_PAID: 'Mark as paid',
  MAX: 'Max',
  MIN: 'Min',
  MONTHLY_STORAGE_PAYMENT_HISTORY: 'Monthly Genetics Storage Payment History',
  MOVING_FROM: 'Moving From',
  MOVING_TO: 'Moving To',
  NEW: 'NEW',
  NEWEST_TO_OLDEST: 'Newest to Oldest',
  NO_ACCOUNTS_FOUND: 'No Accounts Found',
  NO_ANIMAL_OWNERSHIP: 'This Account does not have ownership interest on any animal.',
  NO_ANIMALS_SELECTED: 'No animals selected',
  NO_ASSOCIATED_TRANSACTIONS: 'No Associated Transactions',
  NO_DISABLED_ACCOUNTS_FOUND: 'No Disabled Accounts Found',
  NO_EMBRYO_STRAWS_FOUND: 'No Embryo Straws Found',
  NO_HAVE_MY_OWN_TANK: 'No, I will send my own tank to RSG for shipping',
  NO_MAINTENANCE_HISTORY: 'No maintenance history yet.',
  NEXT_DUE: 'Next Due',
  NEXT_DUE_DATE_OVERRIDE: 'Next Due Override (optional)',
  OVERDUE: 'Overdue',
  PERFORMED_DATE: 'Performed Date',
  REMINDER_ADVANCE_DAYS: 'Reminder Advance (Days)',
  NO_INVENTORY_FOUND: 'No Inventory Found',
  NO_INVENTORY: 'No Inventory Available',
  NO_ITEM_SELECTED: 'No items Selected',
  NO_ITEMS: 'No Items',
  NO_LINKED_STORAGE_MOVEMENTS: 'No Linked Storage Movements',
  NO_LINKED_TRANSACTIONS: 'No Linked Transactions',
  NO_LOCATION_FOUND: 'No Locations Found',
  NO_LOCATIONS_AVAILABLE: 'No Locations Available',
  NO_PAYMENT_DISCREPANCIES_FOUND: 'No Payment Discrepancies Found',
  NO_PENDING_TRANSACTIONS: 'No Pending Transactions',
  NO_PENDING_USE_TRANSACTIONS: 'No Pending Use Transactions',
  NO_RESULTS_FOUND: 'No results found',
  NO_SPECIMENS_AVAILABLE_FOR_CHECK_IN: 'No specimens available for check in.',
  NO_STRAWS_AVAILABLE_FOR_OWNER: 'No straws available for this owner.',
  NO_TRANSACTIONS_FOUND: 'No transactions found',
  NO: 'No',
  NOT_AVAILABLE: 'Not Available',
  NOTE: 'Note',
  NOTES: 'Notes',
  NUMBER_OF_STRAWS: 'Number of straws:',
  OLDEST_TO_NEWEST: 'Oldest to Newest',
  ON_FARM_INVENTORY: 'On-Farm Inventory',
  ORDER_SUMMARY: 'Order Summary',
  ORIGINAL_LOT_QTY: 'Original Lot Quantity',
  ORIGINATION: 'Origination',
  OUTSTANDING_BALANCE: 'Outstanding Balance',
  PAYMENT_HISTORY: 'Payment History',
  PAYMENT_METHOD: 'Payment Method',
  PENDING_DEPOSIT: 'Pending Deposit',
  PENDING_TRANSACTIONS: 'Pending Transactions',
  PENDING_USE_TRANSACTIONS: 'Pending Use Transactions',
  PHONE_NO: 'Phone Number',
  PICKUP: 'Pickup',
  PDF_JPG_DOC: '(pdf, png, jpeg)',
  PNG_JPG_JPEG: '(png, jpg, jpeg)',
  POINT_OF_CONTACT: 'Point of Contact',
  PROCESSING_FEE: 'Processing Fee',
  PROFILE: 'Profile',
  PURCHASE_DETAILS: 'Purchase Details',
  PURCHASE_QUANTITY: 'Purchase Quantity',
  BILL_VENDOR: 'Bill Vendor',
  BILL_VENDOR_NOT_FOUND: 'Bill Vendor not found for this account.',
  STRIPE_ACCOUNT: 'Stripe Account',
  STRIPE_ACCOUNT_NOT_FOUND: 'Payout account not found for this account.',
  STRIPE_ACCOUNT_ID: 'Stripe Account ID',
  PAYOUTS_ENABLED: 'Payouts Enabled',
  DETAILS_SUBMITTED: 'Details Submitted',
  ONBOARDING_STATUS: 'Onboarding Status',
  PAYOUT_SCHEDULE: 'Payout Schedule',
  REQUIREMENTS_DUE: 'Requirements Due',
  ARRIVAL_DATE: 'Arrival Date',
  STRIPE_ONBOARDING_REDIRECT: 'Enter your identity and bank account details to set up payouts.',
  KYC_ONBOARDING: 'KYC Onboarding',
  PENDING_STRIPE_VERIFICATION: 'Pending',
  DOCUMENT_UPLOAD: 'Document Upload',
  CLICK_HERE_TO_UPLOAD_DOCUMENTS: 'Click here to upload verification document',
  ACTION_REQUIRED: 'Action required',
  STRIPE_DOCUMENT_UPLOAD_HELP: 'Please upload a clear and readable copy of the required document.',
  STRIPE_DOCUMENT_UPLOAD_HELP_IDENTITY: 'Upload a clear photo of your government-issued ID.',
  STRIPE_DOCUMENT_UPLOAD_HELP_BANK:
    'Please upload a clear and legible bank account document.',
  STRIPE_DOCUMENT_UPLOAD_FILE_LIMIT: 'Maximum 10 MB per file',
  STRIPE_ADDITIONAL_DOCUMENTS_STILL_REQUIRED:
    'Document submitted. Stripe needs one more document, please upload it below.',
  STRIPE_DOCUMENT_SUBMITTED_IN_REVIEW: 'Document submitted. Stripe is reviewing it, which usually takes a few minutes.',
  STRIPE_UPLOAD_IDENTITY_DOCUMENT: 'Upload Government ID',
  STRIPE_UPLOAD_BANK_DOCUMENT: 'Upload Bank Account Document',
  STRIPE_UPLOAD_ADDRESS_DOCUMENT: 'Upload Proof of Address',
  STRIPE_DOCUMENT_UPLOAD_HELP_ADDRESS:
    'Upload a recent utility bill, bank statement or government letter showing your name and home address.',
  STRIPE_DOCUMENTS_REMAINING: '{count} documents are required. Upload them one at a time.',
  STRIPE_NO_DOCUMENT_REQUESTED: 'Stripe is not requesting any documents right now.',
  STRIPE_ID_BACK_OPTIONAL: 'Back of ID (if your ID has information on both sides)',
  ACTION_REQUIRED_SOON: 'Action Required',
  STRIPE_ACTION_REQUIRED_SOON_BANNER:
    'Payouts are active, but Stripe needs more information ({details}) by {deadline} or payouts will be paused.',
  STRIPE_ACTION_REQUIRED_SOON_NO_DEADLINE_BANNER:
    'Payouts are active, but Stripe needs more information ({details}) soon or payouts will be paused.',
  STRIPE_ACTION_REQUIRED_SOON_UPDATE_DETAILS: 'Use the edit button to update your details.',
  STRIPE_TOS_AGREEMENT_PREFIX: 'I agree to the ',
  STRIPE_TOS_AGREEMENT_LINK: 'Stripe Connected Account Agreement',
  STRIPE_TOS_AGREEMENT_SUFFIX: ', which includes the Stripe Terms of Service.',
  STRIPE_TOS_AGREEMENT_URL: 'https://stripe.com/legal/connect-account',
  STRIPE_FULL_SSN_REQUIRED_HELP: 'Stripe could not verify the last 4 digits of your SSN. Please enter your full 9-digit SSN.',
  FULL_SSN: 'Full SSN (9 digits)',
  VERIFIED: 'Verified',
  PENDING_VERIFICATION: 'Pending Verification',
  ACCOUNT_RESTRICTED: 'Account Restricted',
  ACTION_REQUIRED_DOCUMENT_DUE: 'Document Required',
  STRIPE_RESTRICTED_BANNER_MESSAGE:
    'Your account is restricted from receiving payouts. Please review your account details or contact support.',
  STRIPE_RESTRICTED_DUE_TO_BANNER:
    'Payouts are restricted due to: {details}. Please review your account details or contact support.',
  STRIPE_DOCUMENT_REQUIRED_BANNER_MESSAGE:
    'Action required: Additional verification documents are needed to enable payouts.',
  STRIPE_DOCUMENT_DUE_TO_BANNER:
    'Documents are required due to: {details}. Please upload the requested verification documents to enable payouts.',
  STRIPE_PENDING_BANNER_MESSAGE:
    'Your payout account verification is currently under review. This may take 1-2 business days.',
  STRIPE_PENDING_DUE_TO_BANNER:
    'Stripe is reviewing: {details}. This may take 1-2 business days.',
  STRIPE_PENDING_DOCUMENT_REQUIRED_BANNER_MESSAGE:
    'Additional documents required: Please upload the requested verification documents so we can complete your payout account verification.',
  QB_CUSTOMER: 'QuickBooks Customer',
  QB_CUSTOMER_NAME: 'QB Customer Name',
  QB_CUSTOMER_NOT_FOUND: 'QuickBooks Customer not found for this account.',
  QB_EMAIL_ADDRESS: 'QB Email Address',
  QB_PHONE_NUMBER: 'QB Phone Number',
  QB_REFERENCE_NUMBER: 'QB Reference Number',
  QTY_IN_CANISTER: 'Quantity In Canister',
  QUANTITY_AVAILABLE: 'Quantity Available',
  QUANTITY_OWNED: 'Quantity Owned',
  QUANTITY_TO_DISCARD: 'Quantity to Discard',
  QUANTITY_TO_WITHDRAW: 'Quantity to Withdraw',
  QUANTITY: 'Quantity',
  RECONCILE: 'Reconcile',
  REQUIRED: 'Required',
  RESET_FILTERS: 'Reset Filters',
  RESOLUTION: 'Resolution',
  REVIEW_PURCHASE_INFO: 'Review Purchase Information',
  ROLE: 'Role',
  RSG_INSURANCE_TC: 'Insurance Terms and Conditions',
  NO_SALE_HISTORY_FOUND: 'No sale history found.',
  SEARCH_ANIMAL: 'Search Animal',
  SEARCH_BY: 'Search By',
  SEARCH_EMAIL: 'Search Email',
  SELECT_DATES: 'Select Dates',
  SELECT_ACCOUNT: 'Select Account',
  SELECT_ANIMALS: 'Select Animals',
  SELECT_ITEM_QUANTITY: 'Select Item(s) and Quantity',
  SELECT_ITEM: 'Select Item',
  SELECT_SPECIMEN_TO_VIEW_STORAGE_LOCATIONS: 'Select a specimen to view storage locations',
  SELECT_ONE: 'Select One',
  SELECT_QTY: 'Select Quantity',
  SELECT_TRAVELING_CANISTER: 'Select Traveling Canister',
  SELECT_TYPE: 'Select Type',
  SELECT_IMPORT_TYPE: 'Select which type you want to import',
  SELECT_TEMPLATE_TYPE: 'Select which template you want to download',
  SELECTED_DESIGNATION: 'Selected Designations',
  SELECTED_QTY_TO_USE: 'Selected Qty to Use',
  SELECTED_QTY: 'Selected Qty',
  SELECTED_STRAW_LOTS: 'Selected Straw Lots',
  SELL_INFO: 'Sell Information',
  SELL_TO_NON_EXISTENT_ACCOUNT: 'Sell to Non-Existent Account',
  SELL_TYPE: 'Sell Type',
  SELLER_EMAIL: 'Seller Email',
  SELLER_INFO: 'Seller Information',
  SELLER_NAME: 'Seller Name',
  SELLER_PHONE_NUMBER: 'Seller Phone Number',
  SEMEN: 'Semen',
  SEMEN_TEMPLATE: 'Semen Template',
  SERVICE_CODE: 'Service Code',
  SETUP_DEPOSIT: 'Setup Deposit',
  SINGLE_DEPOSIT: 'Single Deposit',
  SHIP_TO_ADDRESS: 'Ship To Address',
  SHIPMENT_ID: 'Shipment Id',
  SHIPPING_DETAILS: 'Shipping Details',
  SHIPPING_INFO: 'Shipping Information',
  SHIPPING_INSURANCE: 'Shipping Insurance',
  SHIPPING_PAYMENT_HISTORY: 'Shipping Payment History',
  SHOW_HIDE_PASSWORD: 'Show or Hide Password',
  SITE_CODE: 'Site Code',
  SITE_NAME: 'Site Name',
  SITE: 'Site',
  SITES: 'Sites',
  SORT_BY: 'Sort By',
  SEARCH: 'Search',
  SOCIAL_LINKS: 'Social Links',
  START_EDITING: 'Start editing',
  TAGLINE: 'Tagline',
  SPECIMEN_TYPE: 'Specimen Type',
  SPECIMENS: 'Specimen(s)',
  STATUS: 'Status',
  STOCK: 'Stock',
  STORAGE_BREAKDOWN: 'Storage Breakdown',
  STORAGE_LOCATION: 'Storage Location',
  STORAGE_RATES: 'Storage Rates',
  STORAGE_TIER: 'Storage Tier',
  STRAW_DETAILS: 'Straw Details',
  STRAW_DISTRIBUTION: 'Straw Distribution',
  STRAW_LOT: 'Straw Lot',
  TANKS_UP_TO_DATE: 'All tanks are up to date.',
  TANK_INVENTORY_COUNT: 'Tank Inventory Count',
  TANK_MAINTENANCE: 'Tank Maintenance',
  TANK_MAINTENANCE_DUE_BANNER: 'tank(s) need maintenance attention.',
  TANK_MAINTENANCE_SETTINGS: 'Tank Maintenance Settings',
  TANK_MAINTENANCE_SETTINGS_HELP:
    'Set how often On-Farm tanks are due for maintenance and how many days early to show reminders.',
  TANK_CODE: 'Tank Code',
  TANK_NAME: 'Tank Name',
  TANK: 'Tank',
  TANKS: 'Tanks',
  TEAM_MEMBERS: 'Team Members',
  TERMS_AND_CONDITIONS: 'Terms and Conditions',
  TO: 'To',
  TOTAL_CHANGED_QUANTITY: 'Total Changed Quantity',
  TOTAL_QTY_TO_USE: 'Total Qty to Use',
  TOTAL_QUANTITY_SELECTED: 'Total Quantity Selected',
  TOTAL_QUANTITY: 'Total Quantity',
  TOTAL_SELECTED: 'Total Selected',
  TOTAL_UNITS: 'Total Units',
  TRACKING_NUMBER: 'Tracking Number',
  TRANSACTION_ID_NOT_FOUND: 'Transaction ID not found',
  TRANSACTION_LINK_ID: 'Transaction Link ID',
  TRAVELING_TANK: 'Traveling Tank',
  TYPE: 'Type',
  UNITS_OWNED: 'Units Owned',
  UNITS: 'Units',
  UPDATE_PAYMENT_METHOD: 'Update Payment Method',
  UPLOAD_IMAGE: 'Upload Image',
  UPLOAD_IMAGES: 'Upload Images',
  UP_TO_DATE: 'Up to date',
  USE_CARD_ON_FILE: 'Use card on file',
  USE_INFO: 'Use Information',
  USER_DETAILS: 'User Details',
  USER_LOT_NUMBER: 'User Lot Number',
  USER: 'User',
  USERS: 'Users',
  VARIANCE_DETECTED: 'Inventory Variance Detected',
  VARIANCE: 'Variance',
  VIEWING: 'Viewing',
  WITHDRAW_METHOD: 'Withdraw Method',
  YES_NEED_TO_RENT_TANK: 'Yes, I need to rent a tank from RSG',
  YEARS_OF_EXPERIENCE: 'Years of Experience',
  YES: 'Yes',
});

export const MARKETPLACE_CONSTANTS = Object.freeze({
  BREED: 'Breed',
  BREEDER_DETAILS: 'Breeder Details',
  BREEDER: 'Breeder',
  CLEAR_ALL: 'Clear All',
  EMPTY_VALUE: '--',
  EXCLUSIVE_SPECIMEN: 'Exclusive Specimen',
  FILTER: 'Filter',
  FILTER_INITIAL_VISIBLE_COUNT: 5,
  FILTERS: 'Filters',
  FROZEN_BY_RSG: 'Frozen by RSG',
  GENDER: 'Gender',
  MARKETPLACE_NOTICE:
    'A marketplace commission of {commission}% will be deducted from the final selling price. To edit the price of a specimen already listed in the marketplace, please update it from the My Listings page. ',
  MARKETPLACE_PAYMENTS_HISTORY: 'Marketplace Payments History',
  MORE_FROM_BREEDER: 'More from this Breeder',
  NO_MARKETPLACE_SPECIMEN: 'No marketplace specimens found',
  PRICE_RANGE: 'Price Range (USD)',
  PRODUCT_TYPE: 'Product Type',
  PRODUCT_CODE: 'Product Code',
  PER_UNIT: '/Unit',
  PER_STRAW: '/Straw',
  SHOW_LESS: 'Show less',
  SHOW_MORE: 'Show more',
  STOCK: 'Stock',
  STRIPE_PAYOUT_SETUP_REQUIRED_TO_LIST:
    'To receive payouts from marketplace sales, please set up payouts by linking your bank account.',
  STRIPE_PAYOUT_DOCUMENT_REQUIRED:
    'Stripe needs a document to finish verifying your payout account before you can list inventory.',
  STRIPE_PAYOUT_OWNER_ACTION_REQUIRED:
    'Payout details can only be changed by the account owner or an account admin. Please ask them to update them under Settings > Payout Info.',
  STRIPE_PAYOUT_PENDING_VERIFICATION:
    'Your payment information is currently under review. Once it has been verified, you can proceed with adding specimens to the Marketplace.',
  SPECIES: 'Species',
  TOTAL_PRICE: 'Total Price',
  TOTAL_LIST_UNIT: 'Total List Price',
  PRODUCTS_FOUND_SUFFIX: 'products found',
});

export const GUEST_MARKETPLACE_CONSTANTS = Object.freeze({
  EXPLORE_MARKETPLACE_FOR_FREE: 'Explore Marketplace For Free',
  HEADER_TAGLINE:
    'Discover, Buy & Sell Elite Animal Genetics - trusted breeders, premium semen and embryo listings, and a smarter way to grow your herd.',
  OR_DIVIDER: 'or',
  GUEST_MARKETPLACE_PAGE_TITLE: 'RSG Marketplace',
  GUEST_MARKETPLACE_PAGE_SUBTITLE: 'Marketplace',
});

export const MARKETPLACE_CART_CONSTANTS = Object.freeze({
  CLEAR_CART_MODAL_BODY: 'Are you sure you want to remove all items from the cart?',
  CLEAR_CART_MODAL_TITLE: 'Clear Cart',
  EDIT_QUANTITY_MODAL_TITLE: 'Edit Quantity',
  REVIEW_BEFORE_CHECKOUT_HINT: 'Review your marketplace selections before proceeding to checkout',
  MARKETPLACE_CART_SECTION_TITLE: 'Marketplace Transactions',
  SPECIMEN_TYPE_SEMEN: 'semen',
  SPECIMEN_TYPE_EMBRYO: 'embryo',
  TABLE_CELL_EMPTY: '-',
});

export const MARKETPLACE_PROFILE_CONSTANTS = Object.freeze({
  ALT_FACEBOOK: 'Facebook',
  ALT_INSTAGRAM: 'Instagram',
  ALT_WEBSITE: 'Website',
  ALT_YOUTUBE: 'YouTube',
  COMPLETED_SALES: 'Completed Sales',
  EDIT_PROFILE_IMAGE_ARIA: 'Edit profile image',
  ABOUT_FARM_OWN: 'About Your Farm',
  ABOUT_FARM_OTHER: 'About the Farm',
  FARM_SECTION_DESC_OWN: 'Manage your farm information displayed to buyers.',
  FARM_SECTION_DESC_OTHER: 'Information about this breeder.',
  NO_BREEDER_DETAILS: 'No breeder details found.',
  LOCATION: 'Location',
  NO_PROFILE_SET_UP: 'No profile set up yet.',
  PRIMARY_SPECIALIZATION: 'Primary Specialization',
  PLACEHOLDER_ABOUT_FARM: 'Describe your farm and breeding focus.',
  PLACEHOLDER_FARM_NAME: 'Farm name',
  PLACEHOLDER_TAGLINE: 'Primary Specialization',
  PLACEHOLDER_URL: 'https://',
  PLACEHOLDER_YEARS: 'Years of Experience',
  SOCIAL_SECTION_DESC_OWN: 'Add your social media and website to build trust and brand presence.',
  SOCIAL_SECTION_DESC_OTHER: 'Social and website links for this breeder.',
  SUBTITLE_OWN_PROFILE: 'Information visible on your public profile',
  SUBTITLE_OTHER_PROFILE: 'Public profile information for this breeder.',
});

export const NAVIGATION_LINK_CONSTANTS = Object.freeze({
  ACCOUNT: 'Account',
  ADMIN_SETTINGS: 'Admin Settings',
  ANIMAL_MANAGEMENT: 'Animal Management',
  ANIMAL: 'Animal',
  APPLICATION_ADMIN: 'Application Admin',
  APPLICATION_TEAM: 'Application Team',
  CANISTER_CONTENTS: 'Canister Contents',
  CHECK_IN: 'Check In',
  CHECK_OUT: 'Check Out',
  COLLECT_DEPOSIT: 'Collect / Deposit',
  CUSTOM_DATA_POINTS: 'Custom Data Points',
  CUSTOMER_INFO: 'Customer Info',
  DASHBOARD: 'Dashboard',
  ON_FARM_BILLING_MANAGEMENT: 'On-Farm Billing',
  DEPOSIT: 'Deposit',
  FARM_USE: 'Farm Use',
  INSURED_CUSTOMERS: 'Insured Customers',
  INVENTORY_MANAGEMENT: 'Inventory Management',
  INVENTORY: 'Inventory',
  BREEDER_PAYMENTS: 'Breeder Payments',
  COMMISSION_REPORT: 'Commission Report',
  LISTING: 'Listing',
  LISTING_SUMMARY: 'Listing Summary',
  LOCATION_MANAGEMENT: 'Location Management',
  MARKETPLACE: 'Marketplace',
  MARKET_PLACE: 'Marketplace',
  MARKETPLACE_MANAGEMENT: 'Marketplace Management',
  MARKETPLACE_SETTINGS: 'Marketplace Settings',
  MY_LISTING: 'My Listing',
  MY_ORDERS: 'My Orders',
  MY_PROFILE: 'My Profile',
  MOVE: 'Move',
  ON_FARM_INVENTORY: 'Inventory',
  ON_FARM: 'On Farm',
  ON_SITE_SELL: 'On-Site Sell',
  RECONCILE: 'Reconcile',
  REPORTS: 'Reports',
  RSG_CLINIC_USE: 'RSG Clinic Use',
  RSG_INVENTORY: 'RSG Inventory',
  RSG_TRANSACTION_HISTORY: 'RSG',
  SETTINGS: 'Settings',
  SPECIES_BREEDS: 'Species & Breeds',
  TEAM_MANAGEMENT: 'Team Management',
  THRESHOLD: 'Threshold',
  TRANSACTION_HISTORY: 'Transaction History',
  ON_FARM_TRANSACTION_HISTORY: 'On-Farm',
  TRANSACTION_MANAGEMENT: 'Transaction Management',
});

export const NOTIFICATION_CONSTANTS = Object.freeze({
  ACCOUNT_LOCKED:
    'Your account has been locked by the app admin. Please contact RSG Genetics Team to unlock your account at 765-978-0301.',
  ACH_PAYMENT_METHOD_NOTE:
    'Your banking details will undergo a final verification process when the first charge is initiated. Due to the nature of ACH transactions, there might be a delay before any issues with your details are identified. In the event of a grace period before billing starts, this could further extend the time until a failure notification is received. We appreciate your patience and understanding.',
  ACH_PAYMENT_NOT_ALLOWED:
    'We noticed your saved payment method is ACH, which can not be used for insured shipments. Please enter new card details to proceed. Need help? Call us at 765-978-0301 for billing and invoice inquiries.',
  ACH_PAYMENT_NOT_ALLOWED_MARKETPLACE:
    'We noticed your saved payment method is ACH, which can not be used for marketplace transactions. Please enter new card details to proceed. Need help? Call us at 765-978-0301 for billing and invoice inquiries.',
  ADD_PAYMENT_DETAILS: 'Please add payment details to access all the features of this account.',
  ON_FARM_BALANCE_DUE_PREFIX: 'This On-Farm account has a balance due of',
  ON_FARM_BALANCE_DUE_SUFFIX: 'Please pay the outstanding balance to avoid additional charges.',
  ON_FARM_LOCKED_PREFIX: 'On-Farm is',
  ON_FARM_LOCKED_SUFFIX: 'Inventory is view-only until an admin unlocks this account.',
  CC_PROCESSING_FEE_MSG: 'On credit cards, 3% processing fee will be applied.',
  NO_INSURANCE_MESSAGE:
    'Your shipment will be sent with no insurance coverage. RSG is not liable for any damages or loss of genetic material.',
  PAY_NOW_EXISTING_FOOTER: 'Click on "Pay" to clear the outstanding balance.',
  PAY_NOW_NEW_FOOTER:
    'Please note that these details will only be used for a one-time payment to clear the outstanding balance and will not be saved. To save the payment details, please select the above checkbox.',
  PAY_NOW_SET_DEFAULT_METHOD_FOOTER: 'Click on "Save & Pay" to Update the details and clear the outstanding balance.',
  PENDING_ACH_PAYMENT: 'Your account has a past due balance. Access is restricted until the pending payment is processed.',
  SHIPPING_PAYMENT_INFO_SUBHEADER:
    'Please note that if you have opted to add insurance to your order, a credit card number is required to fulfill the order. For further assistance, please call  (765) 978-0301 and select option 4 for billing and invoice inquiries. ',
});

export const PAGE_HEADER_CONSTANTS = Object.freeze({
  ADD_TO_MARKETPLACE: 'Add to Marketplace',
  ADJUST_OWNERSHIP_QUANTITY: 'Adjust Ownership Quantity',
  ADMIN_BILLING_MANAGEMENT: 'Enable/Disable Billing for Accounts',
  ADMIN_SETTINGS: 'Admin Settings',
  ANIMAL_INVENTORY: 'Animal Inventory',
  BILLING_MANAGEMENT: 'Billing Management',
  CANISTER_CONTENTS: 'Canister Contents',
  CHECK_IN_INVENTORY: 'Check In Inventory',
  CHECK_OUT_INVENTORY: 'Check Out Inventory',
  CLINIC_USE: 'RSG Clinic Use',
  COLLECT_DEPOSIT_INVENTORY: 'Collect / Deposit Inventory',
  COMPLETE_DISCARD: 'Complete Discard',
  COMPLETE_WITHDRAW: 'Complete Withdraw',
  CREATE_CLIENT_TRANSACTION: 'Create Client Transaction',
  CREATE_WITHDRAW_TRANSACTION: 'Create Withdraw Transaction',
  CUSTOM_DATA_POINTS: 'Custom Data Points',
  CUSTOMER_INFO: 'Customer Info',
  DISCARD_INVENTORY: 'Discard Inventory',
  EXISTING_ORDERS_FOUND: 'Existing Orders Found',
  LOCATION_INFO: 'Location Info',
  MARKETPLACE_SETTINGS: 'Marketplace Settings',
  MOVE_INVENTORY: 'Inventory Management Move',
  MY_INVENTORY: 'My Inventory',
  ON_FARM_BILLING_MANAGEMENT: 'On-Farm Billing Management',
  ON_FARM_INVENTORY: 'Farm Inventory',
  ON_FARM_LOCATION_INFO: 'Farm Location Info',
  ON_FARM_MANAGEMENT_MOVE: 'Farm Management Move',
  ON_SITE_SELL: 'On-Site Sell',
  ON_FARM_CANISTER_CONTENTS: 'Farm Canister Contents',
  QUICK_VIEW: 'Quick View',
  RECONCILE_INVENTORY_OWNERSHIP: 'Reconcile Inventory & Ownership',
  RECONCILE: 'Inventory Discrepancies',
  SELL_INVENTORY: 'Sell / Transfer',
  SETTINGS: 'Settings',
  SPECIES_BREEDS: 'Species & Breeds',
  THRESHOLD: 'Threshold',
  TRANSACTION_CART: 'Transaction Cart',
  TRANSACTION_MANAGEMENT: 'Transaction Management',
  UPDATE_EXISTING_WITHDRAW: 'Update Existing Withdraw Transaction',
  USE_INVENTORY: 'Use Inventory',
  VIEW_EDIT_TRANSACTION: 'View/Edit Transaction',
  VIEW_TRANSACTION: 'View Transaction',
  WITHDRAW_INVENTORY: 'Withdraw (Ship/Pick Up)',
  WITHDRAW: 'Withdraw',
  MARKETPLACE_LISTING: 'Marketplace Listing',
  MY_LISTING: 'My Listing',
  MY_ORDERS: 'My Orders',
  MY_PROFILE: 'Profile Overview',
  COMMISSION_REPORT: 'Commission Report',
  BREEDER_PAYMENTS: 'Breeder Payments',
});

export const PASSWORDS_CONSTANTS = Object.freeze({
  ADMIN_RESET_PASSWORD_EMAIL_GUIDE:
    "If you haven't received an email, please use the link provided to reset password for RSG's Genetics  Inventory Management Platform.",
  ADMIN_RESET_PASSWORD_GUIDE:
    'The Admins have the capability to generate a reset password link, aiding users in resetting their passwords when necessary. Kindly provide the email address of the user requiring a password reset. Clicking the "Reset Password" button will trigger an email to both the user and the admin initiating the password reset.',
  ADMIN_RESET_PASSWORD: 'Reset Password for Any User',
  CONFIRM_CODE_SUBHEADER: 'Please enter the code we sent to your email.',
  CONFIRM_CODE: 'Confirm Code',
  CREATE_PASSWORD: 'Create Password',
  DIDNT_GET_CODE: "Didn't get a code?",
  FORGOT_PASSWORD_SUBHEADER: "If your email exists, we'll send you an email to help you reset your password.",
  FORGOT_PASSWORD: 'Forgot Password?',
  RESET_PASSWORD_LINK: 'Reset password link',
  RESET_PASSWORD_SUBHEADER: 'Set a new password for your account.',
  RESET_PASSWORD: 'Reset Password',
  SET_PASSWORD_SUBHEADER: "Let's get started on setting a new password for your account",
});

export const PAYMENT_CONSTANTS = Object.freeze({
  ACCOUNT_DETAILS: 'Account Details',
  ACCOUNT_NAME: 'Account Name',
  ACCOUNT_NUMBER: 'Account Number',
  ACH_TRANSFER: 'ACH Transfer',
  ACH: 'ACH',
  ADDITIONAL_AMOUNT: 'Additional Amount',
  AMOUNT: 'Amount',
  BILLING_ADDRESS: 'Billing Address',
  CARD_DETAILS: 'Card Details',
  CARD_NUMBER: 'Card Number',
  CARD: 'Card',
  CONFIRM_ACCOUNT_NUMBER: 'Confirm Account Number',
  CONFIRM_SKIP_PAYMENT_MESSAGE: 'Are you sure you want to skip the payment for this transaction?',
  CVV: 'CVV',
  DIRECT: 'Direct',
  EXISTING_METHOD: 'Existing Method',
  EXPIRY_DATE: 'Expiry Date',
  EXTERNAL: 'External',
  HANDLING_PROCESSING: 'Handling & Processing',
  INSURANCE_AMOUNT: 'Insurance Amount',
  INSURANCE_FEE: 'Insurance Fee',
  INSURANCE: 'Insurance',
  INVENTORY_DUE_AMOUNT: 'Inventory Due Amount',
  MM_YY: 'MM/YY',
  NAME_ON_CARD: 'Name on Card',
  NEW_METHOD: 'New Method',
  NO_INVOICE_PAYMENT_RECORD_IN_QB:
    'The system will not automatically generate an invoice or payment record for this transaction in QuickBooks. These must be manually added in QuickBooks.',
  PAYMENT_HISTORY: 'Payment History',
  PAYMENT_INFO: 'Payment Info',
  PAYOUT_INFO: 'Payout Info',
  PAYOUT_HISTORY: 'Payout History',
  PAYOUT_METHOD: 'Payout Method',
  PAYMENT_INFORMATION: 'Payment Information',
  PAYMENT_METHOD: 'Payment Method',
  PAYMENT_DEFAULT: 'Default',
  ALL_ACH_PURPOSES_IN_USE: 'All ACH payment purposes are already in use on this account.',
  ADD_CARD: 'Add card',
  ROUTING_NUMBER: 'Routing Number',
  ACCOUNT_HOLDER_NAME: 'Account Holder Name',
  ACCOUNT_HOLDER_TYPE: 'Account Holder Type',
  BANK_ACCOUNT: 'Bank Account',
  COMPANY: 'Company',
  DATE_OF_BIRTH: 'Date of Birth',
  DATE_OF_BIRTH_ADULT: 'Enter a valid date of birth. You must be at least 18.',
  INDIVIDUAL: 'Individual',
  PERSONAL_INFORMATION: 'Personal Information',
  SSN_LAST_4: 'Last 4 of SSN',
  SET_DEFAULT_PAYMENT_METHOD: 'Set this as a default payment method',
  SHIPPING_COST: 'Shipping Cost',
  SKIP_PAYMENT_ASSUMED_COMPLETED: 'It is assumed that payment has already been completed outside this system.',
  SKIP_PAYMENT_NO_CARD_REQUIRED: 'No card details will be required.',
  SKIP_PAYMENT_NO_CHARGES_PROCESSED: 'The system will not process any charges for this transaction.',
  TANK_RENTAL_FEE: 'Tank Rental Fee',
  TOTAL_AMOUNT: 'Total Amount',
  UPDATE_INVENTORY_DUE: 'Update Inventory Due Amount',
  UPDATED_INVENTORY_DUE_AMOUNT: 'Updated Inventory Due Amount',
});

export const QUICKBOOKS_CONSTANTS = Object.freeze({
  PAYMENT_DISCREPANCIES: 'Payment Discrepancies',
  PAYMENT_DISCREPANCIES_GUIDE:
    'Review and resolve payment discrepancies between the Inventory app and QuickBooks. You can use the ‘Resync’ option to refresh data from QuickBooks or the ‘Reconcile’ option to manually adjust discrepancies and ensure both systems are aligned. Please carefully review discrepancies before making changes to avoid incorrect financial adjustments.',
  QUICKBOOKS: 'QuickBooks',
  UPDATE_TOKEN_HEADER: 'Update QuickBooks Refresh Token',
});

export const REPORT_CONSTANTS = Object.freeze({
  DETAILS: 'Download a detailed Excel report of all transaction types for the selected date range.',
  REPORT_NOTICE: 'This report exports the transaction history for the selected date range.',
  GUIDE_TITLE: 'How to Download a Report',
  SELECT_DATE_RANGE: 'Select a start date and end date - the date range is required.',
  OPTIONAL_FILTERS: 'Optionally apply filters like transaction type, status, etc.',
  REVIEW_RESULTS: 'Review the matching transactions shown below before downloading.',
  CLICK_TO_DOWNLOAD: "Click 'Download' to export the matching transactions as an Excel report.",
  RESULTS_PREVIEW: 'Matching Results',
  SELECT_DATE_RANGE_TO_PREVIEW: 'Select a date range to preview matching transactions.',
  GENERATE_REPORT: 'Generate Report',
  TRANSACTION_HISTORY_REPORT: 'Transaction History Report',
});

export const RSG_CONSTANTS = Object.freeze({
  PRIVACY_POLICY: 'Privacy Policy',
  RSG_COMMISSION: 'RSG Commission',
  RSG_SIGN_IN_FOOTER: "Don't have an account yet? Let's get you started today",
  RSG_SIGN_IN_SUBHEADER: 'The premier online platform for managing your sheep and goat frozen genetics.',
  RSG_SIGN_UP_FOOTER: "Already have an account? Let's proceed to",
  RSG_SIGN_UP_SUBHEADER:
    'The complete reproductive and wellness solutions service that enhances your sheep and goat breeding business.',
  RSG_STORAGE_RATES: "RSG's Storage Rates",
  RSG_TITLE: 'RSG Client System',
  RSG_WELCOME: 'Welcome to RSG',
  TERMS_OF_USE: 'Terms of Use',
});

export const STORAGE_PLAN_CONSTANTS = Object.freeze({
  FLAT_RATE: 'Flat Rate',
  FOR_6_MONTHS: 'For 6 Months',
  PER_MONTH: 'Per Month',
  PER_UNIT: 'Per Unit',
  STORAGE_RATES_SUBHEADER:
    'Storage costs are calculated monthly based on inventory count. As your inventory grows and shrinks, the system will automatically adjust your rate.',
  STORAGE_RATES: 'Storage Rates',
});

export const ON_FARM_BILLING_CONSTANTS = Object.freeze({
  AGREEMENT_TITLE: 'On-Farm Billing Terms and Conditions',
  AGREEMENT_CHECKBOX: 'I have read, understand, and agree to these Terms and Conditions.',
  AGREEMENT_REQUIRED: 'Please accept the On-Farm billing agreement to activate a tank.',
  AGREEMENT_GATE_BANNER:
    'Please accept the On-Farm Billing Terms and Conditions. On-Farm is view-only until the agreement is accepted.',
  AGREEMENT_GATE_CONTACT_MANAGER: 'Contact your account manager to accept the On-Farm billing agreement.',
  AGREEMENT_REVIEW_ACCEPT: 'Review & Accept',
  SUBHEADER:
    'On-Farm is billed monthly as a flat subscription for digital inventory management. It is separate from RSG facility storage and does not change with inventory count.',
  STANDARD_PLAN: 'Standard Plan',
  CUSTOM_PLAN: 'Custom Plan',
  PER_MONTH: 'Per Month',
  FLAT_RATE: 'Flat Rate',
  CUSTOM_QUOTE: 'Custom Quote',
  ACTIVE_PLAN: 'Active Plan',
  TANKS: 'Tanks',
  UNITS: 'Units / Tank',
  UP_TO_TANKS: (maxTanks: number) => `Up to ${maxTanks} tanks`,
  UNITS_PER_TANK: (units: number) => `${units} units per tank`,
  STANDARD_DESCRIPTION: (maxTanks: number, units: number) =>
    `Flat monthly rate for up to ${maxTanks} tanks, with ${units} units included per tank.`,
  CUSTOM_QUOTE_TITLE: (maxTanks: number) => `More than ${maxTanks} tanks`,
  CUSTOM_QUOTE_DESCRIPTION: 'Contact RSG for a custom quote.',
  PAYMENT_HISTORY_TITLE: 'Monthly On-Farm Payment History',
  SEARCH_HELP: 'Search any account to add, edit, or remove a custom quote, mark On-Farm as paid, or lock On-Farm access.',
  MARK_AS_PAID: 'Mark as Paid',
  LOCK_ON_FARM: 'Lock On-Farm',
  UNLOCK_ON_FARM: 'Unlock On-Farm',
  ADD_CUSTOM_QUOTE: 'Add Custom Quote',
  EDIT_CUSTOM_QUOTE: 'Edit Custom Quote',
  REMOVE_CUSTOM_QUOTE: 'Remove Custom Quote',
  ADD_QUOTE: 'Add Quote',
  EDIT_QUOTE: 'Edit Quote',
  REMOVE_QUOTE: 'Remove Quote',
  LOCK: 'Lock',
  UNLOCK: 'Unlock',
  MARK_PAID: 'Mark Paid',
  MONTHLY_FEE: 'Monthly Fee',
  MAX_TANKS: 'Max Tanks',
  ON_FARM_DUE: 'On-Farm Due',
  PLAN: 'Plan',
  APPROVED_PLAN: 'Approved Plan',
  LOCKED: 'Locked',
  PAST_DUE: 'Past Due',
  ACTIVE: 'Active',
  NOT_STARTED: 'Not Started',
  NOT_USING: 'Not using On-Farm',
  NOT_USING_HINT: 'This account is not using On-Farm. You can add a custom quote if needed.',
  MARK_AS_PAID_CONFIRM: 'Mark this On-Farm balance as paid?',
  LOCK_CONFIRM: 'Lock On-Farm for this account? Inventory will be view-only until unlocked.',
  UNLOCK_CONFIRM: 'Unlock On-Farm for this account?',
  REMOVE_QUOTE_CONFIRM: 'Remove this custom quote? The account will go back to Standard Plan.',
  REMOVE_QUOTE_TOO_MANY_TANKS: (activeTanks: number, maxTanks: number) =>
    `This account has ${activeTanks} active tanks. Standard Plan allows ${maxTanks}. Move or empty extra tanks and deactivate them, then remove the quote.`,
  NO_ON_FARM_ACCOUNTS: 'No On-Farm accounts found',
  EMPTY_ACCOUNTS_HINT: 'Search an account above to add a custom quote or manage billing.',
  ACCOUNTS_LIST: 'On-Farm Accounts',
  FIND_ACCOUNT: 'Find an account',
  NOT_PROVIDED: '—',
});

export const TABLE_HEADER_CONSTANTS = Object.freeze({
  ACCOUNT_BUSINESS_FARM: 'Account / Business / Farm',
  ACCOUNT_OWNER: 'Account / Owner',
  ACCOUNT: 'Account',
  ACQUIRED: 'Acquired',
  ACTION_ITEM: 'Action Item',
  ACTION: 'Action',
  ACTIONS: 'Actions',
  ACTUAL_QTY: 'Actual Qty',
  ACTUAL: 'Actual',
  ADDED_QTY: 'Added Qty',
  ADJUSTED_QTY: 'Adjusted Qty',
  AMOUNT: 'Amount',
  ANIMAL_CODE_NAME: 'Animal Code / Name',
  ANIMAL_CODE: 'Animal Code',
  ANIMAL_ID: 'Animal Id',
  ANIMAL_NAME: 'Animal Name',
  ANIMAL_OWNERSHIP_PER: 'Animal Ownership %',
  ANIMAL: 'Animal',
  AVAILABLE_QTY: 'Available Qty',
  AVAILABLE: 'Available',
  AVERAGE_DAILY_BALANCE: 'Average Daily Balance',
  BEGINNING_QTY: 'Beginning Qty',
  BILLING_CYCLE: 'Billing Cycle',
  BILLING_CYCLE_START: 'Billing Cycle Start',
  BILLING_CYCLE_END: 'Billing Cycle End',
  BILL_DATE: 'Bill Date',
  BREED: 'Breed',
  BREEDER_NAME: 'Breeder Name',
  BUYER: 'Buyer',
  BULK_TRANSACTION_ID: 'Bulk Transaction Id',
  CANISTER: 'Canister',
  CANISTER_QTY: 'Canister Qty',
  CATALOG_QTY: 'Catalog Qty',
  CATEGORY: 'Category',
  CHANGED_QTY: 'Changed Qty',
  CHANGED_QUANTITY: 'Changed Quantity',
  CHECK_IN_QTY: 'Check In Qty',
  CHECK_OUT_QTY: 'Check out Qty',
  CLIENT_NAME: 'Client Name',
  COMMISSION: 'Commission',
  COMM_PERCENT: 'Comm %',
  CURRENT_QTY: 'Current Quantity',
  DAM: 'DAM',
  CREATED_DATE: 'Created Date',
  DATE: 'Date',
  DATE_LISTED: 'Date Listed',
  DATE_SUBMITTED: 'Date Submitted',
  DATE_RANGE: 'Date Range',
  DECREASE: 'Decrease',
  DESCRIPTION: 'Description',
  DESIGNATION: 'Designation',
  DETAILS: 'Details',
  DIFFERENCE: 'Difference',
  DNA: 'DNA',
  DOCUMENT_NAME: 'Document Name',
  EMAIL_ADDRESS: 'Email Address',
  EMBRYO_COUNT: 'Embryo Count',
  EMBRYO_GRADE: 'Embryo Grade',
  EMBRYO_STAGE: 'Embryo Stage',
  EMBRYO_QTY: 'Embryo Qty',
  END_MONTH: 'End Month',
  END_DATE: 'End Date',
  EXPECTED: 'Expected',
  EXPECTED_DATE: 'Expected Date',
  EXPORT_READY: 'Export Ready',
  FINAL_COUNT: 'Final Count',
  FIRST_NAME: 'First Name',
  FLUSH_MATING: 'Flush Mating',
  FREEZE_RECEIVE_DATE: 'Freeze/Receive Date',
  GENDER: 'Gender',
  GROSS: 'Gross',
  GROSS_AMOUNT: 'Gross Amount',
  GROSS_SALES: 'Gross Sales',
  ID: 'ID',
  INCREASE: 'Increase',
  INSURANCE_AMOUNT: 'Insurance Amount',
  INSURANCE_PREMIUM: 'Insurance Premium',
  INVENTORY_DUE_AMOUNT: 'Inventory Due Amount',
  INVENTORY_LOT_NUMBER: 'Inventory Lot Number',
  INVENTORY_TYPE: 'Inventory Type',
  ITEM_TYPE: 'Item Type',
  ITEM: 'Item',
  ITEMS: 'Items',
  LAST_NAME: 'Last Name',
  LAST_PAYMENT: 'Last Payment',
  LEDGER_QTY: 'Ledger Qty',
  LINK_ID: 'Link ID',
  LOCATION: 'Location',
  LOT_DATE_NO: 'Lot Date / Number',
  LOT_NO: 'Lot Number',
  MONTH: 'Month',
  NAME: 'Name',
  NET_AMOUNT: 'Net Amount',
  NET_PAYABLE: 'Net Payable',
  NET_SALE: 'Net Sale',
  NEXT_BILLING_DATE: 'Next Billing',
  ORDER_AMOUNT: 'Order Amount',
  ORDER_DATE: 'Order Date',
  ORDER_ID: 'Order ID',
  ORDERS: 'Orders',
  ORIGINAL_QTY: 'Original Qty',
  ORIGINAL_QUANTITY: 'Original Quantity',
  ORIGINAL: 'Original',
  OWNED_QTY: 'Owned Qty',
  OWNED: 'Owned',
  OWNERSHIP_PERCENTAGE: 'Ownership %',
  PAYMENT_METHOD: 'Payment Method',
  PERIOD: 'Period',
  PERMANENTLY_DISABLED: 'Permanently Disabled',
  PRICE_PER_UNIT: 'Price Per Unit',
  PRICE_UNIT: 'Price / Unit',
  PRODUCT_NAME: 'Product Name',
  PURCHASE_DATE: 'Purchase Date',
  PAYMENT_STATUS: 'Payment Status',
  QB_DUE_AMOUNT: 'QB Due Amount',
  QTY_IN_CANISTER: 'Qty In Canister',
  QTY_LISTED: 'Qty Listed',
  QTY_TO_WITHDRAW: 'Qty to Withdraw',
  QUALITY_PERCENTAGE: 'Quality %',
  QUALITY: 'Quality',
  QUANTITY_OWNED: 'Quantity Owned',
  QUANTITY: 'Quantity',
  REFERENCE_ID: 'Reference Id',
  REMOVED_QTY: 'Removed Qty',
  REMOVED: 'Removed',
  REQUESTED: 'Requested',
  REVENUE: 'Revenue',
  RESULTING_QTY: 'Resulting Qty',
  ROLE: 'Role',
  SELECT: 'Select',
  SELLER: 'Seller',
  SELLER_BREEDER: 'Seller / Breeder',
  PAYMENT_MONTH: 'Payment Month',
  REMAINING: 'Remaining',
  SALE_DATE: 'Sale Date',
  SHIPMENT_ID: 'Shipment Id',
  SHIPPING_COST: 'Shipping Cost',
  SHIPPING_ORDER_ID: 'Shipping Order Id',
  SIRE: 'Sire',
  SITE: 'Site',
  SOLD_QTY: 'Sold Qty',
  SPECIES_BREED: 'Species-Breed',
  START_MONTH: 'Start Month',
  STATUS: 'Status',
  STRAW_LOT: 'Straw Lot',
  STRAW_NUMBER: 'Straw Number',
  START_DATE: 'Start Date',
  AVAILABILITY_STATUS: 'Availability Status',
  TANK: 'Tank',
  THRESHOLD: 'Threshold',
  TOTAL_CATALOG_QTY: 'Total Catalog Qty',
  TOTAL_LISTED: 'Total Listed',
  TOTAL_QTY: 'Total Qty',
  TRACKING_NUMBER: 'Tracking Number',
  TRANSACTION_ID: 'Transaction ID',
  TRANSACTION_DETAILS: 'Transaction Details',
  TRANSACTION_TYPE: 'Transaction Type',
  TYPE: 'Type',
  UNIT_OF_MEASURE: 'Unit Of Measure',
  UNITS_OWNED: 'Units Owned',
  UNITS_SOLD: 'Units Sold',
  UNUSABLE_QTY: 'Unusable Qty',
  UPDATED_ON: 'Updated On',
  USE_QTY: 'Use Qty',
  USED_QTY: 'Used Qty',
  WITHDRAW_QTY: 'Withdraw Qty',
});

export const MARKETPLACE_LISTING_CONSTANTS = Object.freeze({
  ACTIVE_LISTINGS: 'Active Listings',
  CURRENT_PRICE: 'Current Price',
  CURRENT_STOCK: 'Current Stock',
  DEACTIVATE_LISTING: 'Deactivate Listing',
  EDIT_LISTING: 'Edit Listing',
  LISTING_STATUS: 'Listing Status',
  PRODUCT_TYPE: 'Product Type',
  PAYMENT_REPORT: 'Payment Report',
  BREED: 'Breed',
  REASON_FOR_REMOVAL_LABEL: 'Reason for removal',
  REASON_FOR_REMOVAL_PLACEHOLDER: 'Enter reason...',
  REMOVE_LISTING_DESCRIPTION:
    'You are about to remove this listing from the marketplace. Please provide a reason for the removal. This reason may be shared with the breeder.',
  REMOVE_LISTING_HEADER: 'Remove Listing',
  SALE_HISTORY: 'Sale History',
  SEARCH_PLACEHOLDER: 'Search Animal ID or Name',
  SELLER: 'Seller',
});

export const MARKETPLACE_SETTINGS_CONSTANTS = Object.freeze({
  COMMISSION_CONFIGURATION: 'Commission Configuration',
  COMMISSION_CONFIGURATION_DESCRIPTION: 'Define the commission percentage charged by the platform on each completed sale.',
  COMMISSION_RATE_LABEL: 'Commission Rate (%)',
  COMMISSION_HELPER_TEXT: 'This commission is deducted from the order amount before the breeder payout.',
  COMMISSION_APPLICATION_RULES_TITLE: 'Commission Application Rules',
  COMMISSION_RULE_PLATFORM_WIDE: 'Applies to all marketplace sales across the platform',
  COMMISSION_RULE_NEW_ORDERS: 'Effective for new orders only',
  COMMISSION_RULE_NO_RETROACTIVE: 'Does not retroactively affect completed orders',
});

export const MARKETPLACE_MY_ORDERS_LABELS = {
  DATE_RANGE: 'Select Dates',
  PRODUCT_NAME: 'Product Name',
  SEARCH_PRODUCTS: 'Search Products',
  SEARCH_SELLER: 'Search Seller',
  PRODUCT: 'Product',
  QTY: 'QTY',
  TOTAL: 'Total',
} as const;

export const COMMISSION_REPORT_CONSTANTS = Object.freeze({
  DATE_RANGE: 'Date Range',
  ORDER_STATUS: 'Order Status',
  SELLER_BREEDER: 'Seller/Breeder',
  SEARCH_BUYER: 'Search Buyer',
  SEARCH_ANIMAL: 'Search Animal',
  COMMISSION_RATE: 'Commission Rate',
  COMMISSION_DETAILS: 'Commission Details',
  PRODUCT_NOT_AVAILABLE: '-',
  SHOWING_ORDERS_FORMAT: 'Showing {count} completed orders with commission breakdown',
  TOTAL_ORDERS: 'Total Orders',
  GROSS_SALES_AMOUNT: 'Gross Sales Amount',
  TOTAL_COMMISSION_EARNED: 'Total Commission Earned',
  AVG_COMMISSION_PER_ORDER: 'Avg. Commission per Order',
  BUYER_SEARCH: 'buyer',
  SELLER_SEARCH: 'seller',
  ANIMAL_SEARCH: 'animal',
} as const);

export const BREEDER_PAYMENTS_CONSTANTS = Object.freeze({
  UPCOMING_PAYMENTS: 'Upcoming Payments',
  PAYMENT_HISTORY: 'Payment History',
  BREEDER: 'Breeder',
  SEARCH_BY: 'Search By',
  NOT_ATTEMPTED_MARKED_AS_PAID: 'Not Attempted - Marked As Paid',
  MONTH: 'Month',
  DATE_RANGE: 'Date Range',
  TRANSACTION_REFERENCE_ID: 'Transaction Reference ID',
  PAID_DATE: 'Paid Date',
  PAID_AMOUNT: 'Paid Amount',
  PAYMENT_STATUS: 'Payment Status',
  PAYMENT_DETAILS: 'Payment Details',
  SEARCH_BREEDER_PLACEHOLDER: 'Search Breeder',
  ALL_STATUS: 'All Status',
  TOTAL_PENDING_AMOUNT: 'Total Pending Amount',
  TOTAL_BREEDERS_PENDING: 'Total Breeders Pending',
  TOTAL_ORDERS_PENDING: 'Total Orders Pending',
  ALL_BREEDERS: 'All Breeders',
  AWAITING_PAYMENT: 'Awaiting Payment',
  SETTLEMENT_PENDING: 'Settlement Pending',
  MARK_AS_PAID_CONFIRMATION: 'The Outstanding Balance is {amount}, Do you want to mark as paid?',
});

export const TOOLTIP_MESSAGE_CONSTANTS = Object.freeze({
  ADJUST_TOOLTIP_MSG:
    'This transaction, in addition to notes entered below, provides context to why the adjustment is being made.',
  USER_LOT_NUMBER: 'User Lot Number',
  INSURANCE_FEE_TOOLTIP: '5% of the insurance amount.',
});

export const TRANSACTION_CONSTANTS = Object.freeze({
  ASSOCIATED_TRANSACTIONS: 'Associated Transactions',
  BULK_TRANSACTIONS: 'Bulk Transactions',
  CANCEL_TRANSACTION_CONFIRM: 'Are you sure you want to cancel this transaction?',
  CANCEL_TRANSACTION: 'Cancel Transaction',
  LINKED_STORAGE_MOVEMENTS: 'Linked Storage Movements',
  LINKED_TRANSACTIONS: 'Linked Transactions',
  TRANSACTION_DATE: 'Transaction Date',
  TRANSACTION_ID: 'Transaction ID',
  TRANSACTION_INFORMATION: 'Transaction Information',
  TRANSACTION_LINK_ID: 'Transaction Link ID',
  TRANSACTION_NOTES: 'Transaction Notes',
  TRANSACTION_TYPE: 'Transaction Type',
  TRANSACTIONS: 'Transactions',
});

export const VALIDATION_ALERT_CONSTANTS = Object.freeze({
  ACCOUNT_FOUND: 'The account has been found. Please choose the account to complete the sale.',
  INVALID_CODE: 'Invalid Code',
  HISTORY_DOWNLOAD_ALERT: 'Please select a month range to download the report',
  MAX_GREATER_THAN_MIN: 'Max value must be greater than min value',
  MAX_PRICE_GREATER_THAN_RANGE: 'Max value cannot be greater than {maxPrice}',
  MIN_PRICE_LESS_THAN_RANGE: 'Min value cannot be less than {minPrice}',
  MIN_LESS_THAN_MAX: 'Min value must be less than max value',
  MISSING_QUANTITY_COLLECT: 'Please fill Straw Code and Quantity for all embryo straws for each owner.',
  MISSING_QUANTITY: 'Please fill Quantity for all embryo straws.',
  MISSING_STORAGE_LOCATION: 'Please find storage location for all the straw IDs.',
  NO_ACCOUNT_FOUND:
    'No account has been found, or the user is not an authorized buyer on an account. Please provide additional information below to invite the user to create a storage account and complete the sale.',
  RECONCILE_INVENTORY_EXPECTED:
    'Original quantity minus used/removed quantity must be equal to the currently stored quantity in the system.',
  RECONCILE_INVENTORY_OWNED: 'Owned quantity must be equal to the currently stored quantity in the system.',
  REQUIRED_FIELD: 'This field is required.',
  SAME_SOURCE_AND_DESTINATION_CANISTER: 'Source and destination canister must be different.',
  SELECT_VALID_FROM_AND_TO_MONTH: 'Please ensure the "To" month is later than the "From" month.',
  SITE_TANK_CANISTER_REQUIRED: 'Site, tank, and canister are required',
  STORAGE_QTY_GREATER_THAN_0: 'Storage location quantity must be greater than 0',
  STORAGE_QTY_MUST_EQUAL: 'Storage location quantity must equal',
  STRAW_QTY_MISMATCH: 'Please match your storage quantity with the straw quantity.',
  TOTAL_QUANTITY_MISMATCH: 'Total quantity for this owner should match the ownership breakdown.',
  UNAUTHORIZED_CATALOG_SELL:
    'Unauthorized: You do not have permission to sell to this user. Kindly provide the different email address.',
  UNIQUE_ANIMAL_CODE: 'Animal Code must be unique',
  UNIQUE_LOT_NUMBER: 'Lot number must be unique',
  UNIQUE_STRAW_NUMBER: 'Straw Number must be unique',
  WITHDRAW_QTY_EXCEEDED: 'Total quantity selected for the specimen is more than the quantity to withdraw.',
});

export const URL_CONSTANTS = Object.freeze({
  TERMS_OF_USE_URL:
    'https://reprospecialty.com/wp-content/uploads/2023/10/2023-Semen-and-Embryo-Storage-Agreement-Terms-and-Conditions-for-RSGinventory.pdf',
  PRIVACY_POLICY_URL: 'https://reprospecialty.com/wp-content/uploads/2023/10/PRIVACY-POLICY-for-RSGinventory.pdf',
});

export const SALE_HISTORY_CONSTANTS = {
  SHOWING: 'Showing',
  PRODUCTS: 'Products',
  TOTAL_UNITS_SOLD: 'Total Units Sold',
  TOTAL_REVENUE: 'Total Revenue',
  TOTAL_ORDERS: 'Total Orders',
  ACTIVE_PRODUCTS: 'Active Products',
  ACTIVE_STATUS: 'Active',
  PERCENT_SOLD: '% Sold',
};

export const REDIRECTING = 'Redirecting...';
export const RETURN_TO_SIGN_IN = 'Return To Sign In';
export const STAY_SIGNED_IN = 'Stay Signed In';
